import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-558ba257"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queues-list" }

import { computed, onMounted, PropType, ref, watch } from 'vue';
import { QueueRelationModel } from '@/components/task-forms/models';
import { default as QueuesListItem } from './queues-list-item.vue';
import { TirPmScrollbar } from 'tir-components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'queues-list',
  props: {
  /**id проекта */
  projectId: { type: Number, required: true },
  /**Список очередей задачи */
  queues: { type: Array as PropType<QueueRelationModel[]> },
  editing: { type: Boolean, default: true },
  /**id выбранной очереди */
  selectedQueueId: { type: String },
  /**ссылка на компонент скролбара */
  scrollbar: { type: Object as PropType<InstanceType<typeof TirPmScrollbar>> },
},
  emits: ["remove"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Ссылка на подзадачи */
const $queuesList = ref<InstanceType<typeof QueuesListItem>>();

/**Выбраный элемент очереди */
const selectElementQueue = computed(() => {
  return props.queues.findIndex((queue) => queue.Id === props.selectedQueueId);
});

/**Очередь */
const queueElement = computed(() => {
  return $queuesList.value[selectElementQueue.value]?.queueItem;
});

/**Спуститься до задачи */
const scrollToLastElement = () => {
  const scrollContainer = props.scrollbar.$scroll;

  const currentScrollTop = scrollContainer.scrollTop;
  const targetScrollTop =
    currentScrollTop +
    queueElement.value.getBoundingClientRect().top -
    scrollContainer.getBoundingClientRect().top -
    20;

  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
};

__expose({
  queuesList: $queuesList,
});

watch(
  () => props.queues,
  () => {
    if (selectElementQueue.value > -1) scrollToLastElement();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queues, (queue, idx) => {
      return (_openBlock(), _createBlock(QueuesListItem, {
        ref_for: true,
        ref_key: "$queuesList",
        ref: $queuesList,
        projectId: __props.projectId,
        queue: queue,
        key: idx,
        onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove', $event))),
        editing: __props.editing
      }, null, 8, ["projectId", "queue", "editing"]))
    }), 128))
  ]))
}
}

})